/**
 * Sales charts troubleshooting. Filter console by `[SalesCharts]`.
 * In production builds, set `window.__DEBUG_SALES_CHARTS = true` then reload.
 */
export function salesChartsDebug(label, data) {
  try {
    const force =
      typeof window !== "undefined" && window.__DEBUG_SALES_CHARTS === true;
    if (!force && process.env.NODE_ENV !== "development") {
      return;
    }
    if (data !== undefined) {
      console.info("[SalesCharts]", label, data);
    } else {
      console.info("[SalesCharts]", label);
    }
  } catch (_e) {
    /* ignore */
  }
}
